/*
    Autogenerated class model from django KeyWordCategory
    -- 2023-03-13 18:02:20.827802
*/
import Vue from 'vue';

// BaseObjectClass defines methods load, save, delete
import { BaseObjectClass, BaseCollection, BaseStoreCollection } from '@/base_object_class';

class KeyWordCategoryClass extends BaseObjectClass {
    constructor(rawData = {}) {
        super();
        this.populate(rawData);
    }

    populate(rawData = {}) {
        Vue.set(this, 'isLoading', false);
        Vue.set(this, 'pk', rawData.pk || null);
        Vue.set(this, 'id', rawData.pk || null);
        Vue.set(this, 'createdAt', new Date(rawData.createdAt));
        Vue.set(this, 'updatedAt', new Date(rawData.updatedAt));

        /* Define default values here if needed */
        Vue.set(this, 'order', rawData.order);
        Vue.set(this, 'name', rawData.name);
    }

    getBaseUrl() {
        return '/listepro/key-word-category/';
    }

    get isValid() {
        return true;
    }
}

class KeyWordCategoryCollection extends BaseCollection {
    initModel(rawData) {
        return new KeyWordCategoryClass(rawData);
    }

    getBaseUrl() {
        return '/listepro/key-word-category/';
    }
}

class KeyWordCategoryStoreCollection extends BaseStoreCollection {
    initModel(rawData) {
        return new KeyWordCategoryClass(rawData);
    }

    getBaseUrl() {
        return '/listepro/key-word-category/';
    }

    getStorePath() {
        return 'listepro/keyWordCategoryCollection';
    }
}

export {
    KeyWordCategoryClass,
    KeyWordCategoryCollection,
    KeyWordCategoryStoreCollection,
};
